import Item from 'common/ITEMS/Item';

const items = {
  //region Discipline

  //endregion

  //region Holy

  //endregion

  //region Shadow

  //endregion

  //region Shared
  GLYPH_OF_THE_LIGHTSPAWN: {
    id: 153031,
    name: 'Glyph of the Lightspawn',
    icon: 'inv_glyph_minorpriest',
  },
  //endregion
} satisfies Record<string, Item>;
export default items;
